import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'

dayjs.extend(duration)

export function useNumber() {
    function count(value: number, singular: string, plural?: string) {
        return value === 1 ? `1 ${singular}` : `${value} ${plural || singular + 's'}`
    }

    function age(birthDate?: string) {
        if (!birthDate) return
        const years = dayjs().diff(birthDate, 'years')
        return `${years}y`
    }

    function duration(startDate: string, endDate?: string) {
        if (!endDate) return
        const duration = dayjs.duration(dayjs(endDate).diff(startDate))
        const minutes = duration.minutes()
        const seconds = duration.seconds()
        return `${minutes ? minutes + 'm' : ''} ${seconds ? seconds + 's' : ''}`
    }

    return {
        count,
        age,
        duration,
    }
}
